<template>
  <div class="loginForm modal fade" id="printerInfoModal">
    <row class="modal-dialog" role="document" style="width: 100%">
      <column class="col-md-1"></column>
      <column class="col-md-10">
        <va-box :title="title" theme="box-info" :isBorder="true" widgetType="">
          <div slot="content">
            <div class="col-sm-3" v-for="item in printerInfo">
              <div class="description-block" style="background-color: #eee; padding: 5px; height: 50px;">
                <div class="description-text text-left">{{item.title}}</div>
                <h6 class="description-header">{{item.value}}</h6>
              </div>
            </div>
          </div>
          <div slot="footer">
            <va-button :isBlock="false" theme="danger" name="Close" align="right" @click.native="cancel"></va-button>
          </div>
        </va-box>
      </column>
      <column class="col-md-1"></column>
    </row>
  </div>
</template>
<script>
  import VAAlert from './VAAlert'
  import VABox from './VABox'
  import VAButton from './VAButton'

  // import { db } from '../firebase'

  export default {
    name: 'PrinterInfo',
    data () {
      return {
        printer: null,
        printerInfo: [],
        title: 'Printer Info',
        error: ''
      }
    },
    created () {

    },
    mounted () {
      this.$bus.$on('printerInfoModal-open', (args) => {
        // console.log(args)
        this.printerInfo = []
        if (args) {
          this.printer = args
          this.title = 'Printer Info ' + '[' + this.printer.MacAddress + ']'
          this.title = 'Printer Info ' + '[' + this.printer['.key'] + ']'

          this.printerInfo.push({ title: 'Date', value: this.printer.Logged })
          this.printerInfo.push({ title: 'MAC Address', value: this.printer.MacAddress })
          this.printerInfo.push({ title: 'IP Address', value: this.printer.IPAddress })
          this.printerInfo.push({ title: 'Status', value: this.printer.Status })

          this.printerInfo.push({ title: 'Black Tonert', value: this.printer.BlackTonerLeft })
          this.printerInfo.push({ title: 'Cyan Toner', value: this.printer.CyanTonerLeft })
          this.printerInfo.push({ title: 'Magenta Toner', value: this.printer.MagentaTonerLeft })
          this.printerInfo.push({ title: 'Yellow Toner', value: this.printer.YellowTonerLeft })

          this.printerInfo.push({ title: 'Pages', value: this.printer.PageCount })
          this.printerInfo.push({ title: 'Model', value: this.printer.ModelName })
          this.printerInfo.push({ title: 'Serial', value: this.printer.PrinterSerial })
          this.printerInfo.push({ title: 'Host', value: this.printer.HostName })

          this.printerInfo.push({ title: 'A4 Black', value: this.printer.A4Black })
          this.printerInfo.push({ title: 'A4 Color', value: this.printer.A4Color })
          this.printerInfo.push({ title: 'A3 Black', value: this.printer.A3Black })
          this.printerInfo.push({ title: 'A3 Color', value: this.printer.A3Color })

          this.printerInfo.push({ title: 'Copy', value: this.printer.Copy })
          this.printerInfo.push({ title: 'Scan', value: this.printer.Scan })
          this.printerInfo.push({ title: 'Duplex', value: this.printer.Duplex })
          this.printerInfo.push({ title: 'Fax', value: this.printer.Fax })

          this.printerInfo.push({ title: 'Location', value: this.printer.Location })
          this.printerInfo.push({ title: 'Error', value: this.printer.ErrorString })
          this.printerInfo.push({ title: 'Customer', value: this.printer.Customer })
          this.printerInfo.push({ title: 'Site', value: this.printer.Site })
          $('#printerInfoModal').modal('show')
        } else {
          this.$root.showAlert('Printer Info', 'Missing Printer Data, Please try again later!')
        }
      })
    },
    components: {
      'va-alert': VAAlert,
      'va-box': VABox,
      'va-button': VAButton
    },
    methods: {
      cancel () {
        $('#printerInfoModal').modal('hide')
      },
      getPercent (colorLeft) {
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            return '0%'
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          return colorLeft + '%'
        } else {
          return '0%'
        }
      }
    }
  }

</script>



// WEBPACK FOOTER //
// PrinterInfo.vue?8768dc80